module.exports = __webpack_public_path__ + "static/img/video.49dd0e69.png";